<template>
    <div class=" contact-info-container">
        
        
        <div class="pointer flex contact-us">
            <img class="icon-pic mr-10" src="@/assets/img/icon_01.png">
            <a style="font-size: 16px" target="_top" href="mailto:cnfmkpmgclicbt@kpmg.com">{{ $t('newsMgt.contactTeam') }}</a>
        </div>
        <div class="pointer flex site-service" @click="toOuterLink(serviceDeskUrl)">
            <img class="icon-pic mr-10" src="@/assets/img/icon_02.png">

            <div class="font-bold">{{ $t('newsMgt.serviceDesk') }}</div>
        </div>
    </div>
</template>
<script>
import SvgIcon from "@/components/svgIcon/index";

export default{
    name:'ContentTopRight',
    props:{
        isKp:{
            type:Boolean,
            default:()=>true
        }
    },
    components:{ SvgIcon },
    data(){
        return{
            serviceDeskUrl:'https://oak-cn.cn.kworld.kpmg.com/#/user/createticketfromprofiles'
        }
    },
    mounted(){
    },
    methods:{
        toOuterLink(url){
            if(!url) return
            window.open(url)
        },
    }
}
</script>
<style scoped>
.font-bold{
    font-weight: bold;
    font-size: 16px
}

.contact-info-container{
    width: calc(100%);
    color: white;
    /* font-size: 12px; */
    /* position: absolute;
    right: 0;
    top:0; */
    display: inline-flex;
    height: 62px;
    margin-top: 0px;
}


.icon-pic{
    width: 36px;
    height: 36px;
}
.site-service{
    /* height: 40px; */
    padding: 10px;
    background: #FDEFF3;
    background-size: cover;
    cursor: pointer;
    border-radius: 4px;
    width: 50%;
    width: calc((100% - 36px) / 2);
    align-items: center;
    margin-left: 20px;
}

.site-service .font-bold {
    color: #000;
}

.contact-us{
    /* height: 40px; */
    padding: 10px;
    background: #E7FCFD;
    background-size: cover;
    border-radius: 4px;
    width: 50%;
    width: calc((100% - 36px) / 2);
    align-items: center;
}

.contact-us a {
    color: #000;
    font-weight: bold;
}
</style>